import type { LatLong } from '@iheartjane/geolocation';
import { pluralize as pluralizeWord } from '@iheartjane/utils';
import isEmpty from 'lodash-es/isEmpty';

import type { Address } from '@jane/shared/types';

import { distance } from './location';

function pluralizeDistance(miles: number) {
  return pluralizeWord({ noun: 'mile', number: miles, returnValue: 'word' });
}

export function calculateDistance(
  userCoordinates: LatLong | undefined,
  storeCoordinates: LatLong
) {
  if (!userCoordinates || isEmpty(userCoordinates)) return 0;
  return parseFloat(distance(userCoordinates, storeCoordinates));
}

export function presentDistance(
  userCoordinates?: LatLong,
  storeCoordinates?: LatLong
) {
  if (!(
    userCoordinates &&
    userCoordinates.lat &&
    userCoordinates.long &&
    storeCoordinates &&
    storeCoordinates.lat &&
    storeCoordinates.long
  ))
    return '';

  const distance = calculateDistance(userCoordinates, storeCoordinates);

  return `${distance} ${pluralizeDistance(distance)} away`;
}

export const deliveryCoordinates = (
  deliveryAddress: Address | null
): LatLong | undefined =>
  deliveryAddress && deliveryAddress.lat && deliveryAddress.lng
    ? {
        lat: deliveryAddress.lat,
        long: deliveryAddress.lng,
      }
    : undefined;
